import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Range } from "@graphistry/rc-slider";
import "@graphistry/rc-slider/assets/index.css";
import { Dropdown } from "semantic-ui-react";
import { Input } from "antd";

import { Column } from "../../genericComponents/Layout";
import { Button } from "../../genericComponents";
import { ThemeProps as theme } from "../../genericComponents/globalStyles";
import { useQuery } from "@apollo/client";
import {
  GET_SPECIALTIES,
  GET_SCHOOLS,
  GET_USERNAMES,
} from "../../../helpers/graphqlQueries";

const class_statusList = [
  "High School",
  "Undergraduate",
  "Applicant",
  "Growth Year",
  "Reapplicant",
  "Admitted",
  "Resident",
  "Fellow",
  "Practicing ",
  "Other", 
];

const class_status = class_statusList.map((option, index) => ({
  text: option,
  key: index,
  value: option,
}));


const FiltersContainer = styled(Column)`
h1{
  font-size: 32px;

}
background-color: rgba(51, 120, 89, 0.22);
padding:20px;
border-radius: 6px;

  margin-right: 30px;
  min-width: 350px;
  max-height: 900px;
  width: 30%;
  display: flex;
  margin-bottom: 32px;
  @media (max-width: 720px) {
    width: 100%;
    margin-right: 0px;
  }
`;
const ListItem = styled.div`
  margin: 5px 0;
`;
const FilterSection = styled.div`
h2 {
  color: rgb(17, 23, 66);
}
  margin-bottom: 25px;
`;
const FilterButonsList = styled.div`
  display: flex;
  justify-content: space-evenly;
`;
const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 300px;
`;

const Filter = styled(Button)`
  padding: 9px 45px;
  background: ${(props) => props.theme.color.darkBlue};
  color: ${(props) => props.theme.color.white};
`;
const ClearFilter = styled(Button)`
  background: ${(props) => props.theme.color.softPurple};
  color: ${(props) => props.theme.color.black};
`;

const SideFilter = ({ onPressFilter, usersnameList }) => {
  const defaultFiltersState = {
    class_status: "",
    location: "",
    MCAScore: [0, 1000],
    stepOneScore: [0, 1000],
    stepTwoScore: [0, 1000],
    stepThreeScore: [0, 1000],
    medical_school: "",
    specialty: "",
    username: "",
    looking: "",
    offer: "",

  };

  const lookingOrOffer = [
    'MENTORSHIP',
    'TUTORING',
    'NETWORKING',
    'STUDY GROUPS',
    'FRIENDSHIP',
    'ACCOUNTABILITY PARTNERING',
    'CLINICAL EXPERIENCE',
    'RESEARCH EXPERIENCE',
  ];

  const lookingOrOfferList =lookingOrOffer.map((option, index) => ({
    text: option,
    key: index,
    value: option,
  }))

  const [filters, setFilters] = useState(defaultFiltersState);
  const [schools, setSchools] = useState([]);
  const [specialties, setSpecialties] = useState([]);
  const [usersnames, setUsersnames] = useState([]);

  useQuery(GET_USERNAMES, {
    onCompleted: (data) =>
      setUsersnames(
        data.user_account.map((user, index) => ({
          text: user.username,
          key: index,
          value: user.username,
        }))
      ),
  });

  useQuery(GET_SCHOOLS, {
    onCompleted: (data) =>
      setSchools(
        data.school_programs.map((school, index) => ({
          text: school.school_name,
          key: school.index,
          value: school.school_name,
        }))
      ),
  });

  useQuery(GET_SPECIALTIES, {
    onCompleted: (data) =>
      setSpecialties(
        data.medical_specialties.map((speciality) => ({
          text: speciality.specialties_name,
          key: speciality.id,
          value: speciality.specialties_name,
        }))
      ),
  });

 

  function handleSetFilter(filterName, value) {
    setFilters({
      ...filters,
      [filterName]: value,
    });
  }
  return (
<Sidebar>
<h1>Members</h1>
    <FiltersContainer>
      <h1>Filter</h1>
      <FilterSection>
        <h2>members looking for</h2>
        <Dropdown
          placeholder='search user looking for '
          value={filters.looking}
          fluid
          search
          selection
          options={lookingOrOfferList}
          onChange={(_, data) => handleSetFilter("looking", data.value)}
        />
      </FilterSection><FilterSection>
        <h2>members offering</h2>
        <Dropdown
          placeholder='search user offering'
          value={filters.offer}
          fluid
          search
          selection
          options={lookingOrOfferList}
          onChange={(_, data) => handleSetFilter("offer", data.value)}
        />
      </FilterSection>
      <FilterSection>
        <h2>by username</h2>
        <Dropdown
          placeholder='Select Username'
          value={filters.username}
          fluid
          search
          selection
          options={usersnames}
          onChange={(_, data) => handleSetFilter("username", data.value)}
        />
      </FilterSection>
      <FilterSection>
        <h2>by class status</h2>
        <ListItem>
          <Dropdown
            placeholder='Select Year'
            fluid
            selection
            value={filters.class_status}
            onChange={(_, r) => handleSetFilter("class_status", r.value)}
            options={class_status}
          />
        </ListItem>
      </FilterSection>
      <FilterSection>
        <h2>by school</h2>
        <ListItem>
          <Dropdown
            placeholder='Select Medical School'
            fluid
            selection
            search
            value={filters.medical_school}
            onChange={(_, r) => handleSetFilter("medical_school", r.value)}
            options={schools}
          />
        </ListItem>
      </FilterSection>
      <FilterSection>
        <h2>by speciality</h2>
        <ListItem>
          <Dropdown
            placeholder='Select Speciality'
            fluid
            selection
            search
            value={filters.specialty}
            onChange={(_, r) => handleSetFilter("specialty", r.value)}
            options={specialties}
          />
        </ListItem>
      </FilterSection>
      <FilterButonsList>
        <ClearFilter
          onClick={() => {
            setFilters(defaultFiltersState);
            onPressFilter(defaultFiltersState);
          }}
        >
          Clear Filters
        </ClearFilter>
        <Filter onClick={() => onPressFilter(filters)}>Filter</Filter>
      </FilterButonsList>
    </FiltersContainer>
    </Sidebar>
  );
};

export default SideFilter;
